var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`col-${_vm.layout.size} ${_vm.layout.class}`,style:(_vm.layout.style)},_vm._l((_vm.layout.children),function(child,index){return _c('Views',{key:index,attrs:{"view":child,"topbarControls":_vm.topbarControls,"setTopbarControls":_vm.setTopbarControls}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }